import type {
  IProductHeaderButtonProps,
  IProductHeaderMedicineInfo,
  IProductHeaderProductInfo,
  IProductHeaderProps,
  IProductHeaderReviewCompactProps,
} from './types'

import { Children, isValidElement } from 'react'
import {
  ProductHeaderFirstButton,
  ProductHeaderImage,
  ProductHeaderMedicineInfo,
  ProductHeaderProductInfo,
  ProductHeaderReviewCompact,
  ProductHeaderSecondButton,
  ProductHeaderTag,
  ProductHeaderTitle,
} from './components'
import * as Comp from './product-header.styles'

const ProductHeaderRoot = ({
  children,
  testID = 'productHeaderTest',
  ...props
}: IProductHeaderProps) => {
  const renderInternalHeaderComponents = Children.map(children, child => {
    if (!isValidElement(child)) return

    if (child.type === ProductHeaderTag) return child
    if (child.type === ProductHeaderTitle) return child
  })

  const renderInternalImageComponent = Children.map(children, child => {
    if (!isValidElement(child)) return

    if (child.type === ProductHeaderImage) return child
  })

  const renderInfoInternalComponents = Children.map(children, child => {
    if (!isValidElement(child)) return

    if (child.type === ProductHeaderProductInfo) return child
    if (child.type === ProductHeaderMedicineInfo) return child
    if (child.type === ProductHeaderReviewCompact) return child
  })

  const renderButtonInternalComponents = Children.map(children, child => {
    if (!isValidElement(child)) return

    if (child.type === ProductHeaderFirstButton) return child
    if (child.type === ProductHeaderSecondButton) return child
  })

  return (
    <Comp.Root {...props} testID={testID}>
      <Comp.Header>
        {renderInternalImageComponent}
        <Comp.HeaderContent>
          {renderInternalHeaderComponents}
        </Comp.HeaderContent>
      </Comp.Header>
      <Comp.Info>
        <Comp.InfoContent>{renderInfoInternalComponents}</Comp.InfoContent>
        <Comp.ButtonsContainer>
          {renderButtonInternalComponents}
        </Comp.ButtonsContainer>
      </Comp.Info>
    </Comp.Root>
  )
}

export const ProductHeader = {
  Root: ProductHeaderRoot,
  Image: ProductHeaderImage,
  FirstButton: ProductHeaderFirstButton,
  SecondButton: ProductHeaderSecondButton,
  Tag: ProductHeaderTag,
  Title: ProductHeaderTitle,
  ProductInfo: ProductHeaderProductInfo,
  MedicineInfo: ProductHeaderMedicineInfo,
  ReviewCompact: ProductHeaderReviewCompact,
}

export type {
  IProductHeaderProps,
  IProductHeaderButtonProps,
  IProductHeaderMedicineInfo,
  IProductHeaderProductInfo,
  IProductHeaderReviewCompactProps,
}
